import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "header-with-icon"
}
const _hoisted_2 = { class: "header-with-icon__icon-wrapper" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "ds-promo-banner-new__body" }
const _hoisted_6 = { class: "ds-promo-banner-new__texts" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "ds-promo-banner-new__buttons" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href", "target", "rel", "data-game-id", "data-app-event", "data-app-argument"]
const _hoisted_13 = {
  key: 1,
  class: "cp-pop-over__stream-banner"
}
const _hoisted_14 = { class: "lotteries-stream-banner__badge" }
const _hoisted_15 = { class: "lotteries-stream-banner__badge-icon" }

import { computed, onMounted } from "vue";
import { isMobileApp, triggerMobileAppEvent } from "@sazka/mobile-apps/mobile-app-integration";
import { UrlUtils } from "@sazka/utils/url";
import {
    DsPromoBannerNewDto,
    DsPromoBannerNewHeaderType,
    DsPromoBannerNewLinkType,
    DsPromoBannerNewType,
} from "./ds-promo-banner-new";
import DsButton from "../button/ds-button.vue";
import DsIcon from "../icon/ds-icon.vue";
import { SvgIcons } from "../icon/types";
import WebpImage from "../image/webp-image.vue";
import { Theme } from "../types/theme";
import WebpWebmMedia from "../video/webp-video.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ds-promo-banner-new',
  props: {
    banner: {},
    size: { default: "low" },
    analyticsBannerPage: {}
  },
  emits: ["bannerMount", "bannerClick", "openVideoStream"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const bannerSizeClass = computed(() => (__props.size && __props.size != "default" ? `ds-promo-banner-new--${__props.size}` : ""));

const theme = computed(() => {
    return __props.banner.dsTheme.toLowerCase() as Theme;
});

const link = computed(() => {
    if (__props.banner.linkType === DsPromoBannerNewLinkType.Url && __props.banner.urlLink) {
        const url = __props.banner.urlLink?.replace("~/", "/");

        if (!url) return null;

        let bannerPage = "else";
        if (environment.nodeAliasPath === "/loterie") {
            bannerPage = "mainCategoryPopoverBanner";
        } else if (environment.nodeAliasPath === "/moje-sazky/vsazene") {
            bannerPage = "mainMyBetsBanner";
        } else if (environment.nodeAliasPath.endsWith("/kontrola-a-vysledky")) {
            bannerPage = "mainCheckBetBanner";
        }

        return UrlUtils.addQueryParameter(url, `bannerPage=${bannerPage}`);
    }

    return __props.banner.urlLink;
});

const linkClass = computed(() => {
    switch (__props.banner.linkType) {
        case DsPromoBannerNewLinkType.Casino:
            return "game-launcher";
        case DsPromoBannerNewLinkType.Video:
            return "btn-video";
        default:
            return "";
    }
});

function onClickBanner(event: Event) {
    if (__props.banner.mobileAppEvent && isMobileApp) {
        event.preventDefault();
        triggerMobileAppEvent(__props.banner.mobileAppEvent, __props.banner.mobileAppArgument);
    }

    emit("bannerClick");
}

const openVideoStream = () => {
    emit("openVideoStream");
};

onMounted(() => {
    emit("bannerMount");
});

return (_ctx: any,_cache: any) => {
  return (_ctx.banner.type === _unref(DsPromoBannerNewType).Link)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["ds-promo-banner-new", bannerSizeClass.value])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["ds-promo-banner-new__inner", [`ds-promo-banner-new__inner--${theme.value}`, { 'ds-promo-banner-new--gradient': _ctx.banner.gradient }]])
        }, [
          (_ctx.banner.headerType !== _unref(DsPromoBannerNewHeaderType).None)
            ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
                (_ctx.banner.headerType === _unref(DsPromoBannerNewHeaderType).Text)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(DsIcon, {
                          name: (_ctx.banner.headerIcon as SvgIcons),
                          width: 16,
                          height: 16
                        }, null, 8, ["name"])
                      ]),
                      _createElementVNode("h3", {
                        class: "header-with-icon__text",
                        innerHTML: _ctx.banner.headerText
                      }, null, 8, _hoisted_3)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", {
                        class: _normalizeClass([
                            'header-with-icon__promo-icon-outer',
                            `header-with-icon__promo-icon-outer--${_ctx.banner.lottery}`,
                        ])
                      }, [
                        _createVNode(WebpImage, {
                          src: _ctx.banner.lotteryHeaderImage,
                          "css-class": "header-with-icon__promo-icon",
                          get2x: true,
                          alt: ""
                        }, null, 8, ["src"])
                      ], 2),
                      _createElementVNode("h3", {
                        class: "header-with-icon__text",
                        innerHTML: 
                            _ctx.banner.headerType === _unref(DsPromoBannerNewHeaderType).LotteryIconCustomText
                                ? _ctx.banner.headerText
                                : _ctx.banner.lotteryDisplayName
                        
                      }, null, 8, _hoisted_4)
                    ], 64))
              ]))
            : _createCommentVNode("", true),
          _createVNode(WebpImage, {
            src: _ctx.banner.backgroundImage,
            "css-class": "ds-promo-banner-new__bg",
            alt: ""
          }, null, 8, ["src"]),
          (_ctx.banner.image)
            ? (_openBlock(), _createBlock(WebpWebmMedia, {
                key: 1,
                src: _ctx.banner.image,
                "css-class": "ds-promo-banner-new__image",
                "loop-video": true,
                alt: ""
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h4", {
                class: "ds-promo-banner-new__heading",
                innerHTML: _ctx.banner.headline
              }, null, 8, _hoisted_7),
              (_ctx.banner.text)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "ds-promo-banner-new__description",
                    innerHTML: _ctx.banner.text
                  }, null, 8, _hoisted_8))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_ctx.banner.buttonText && _ctx.banner.linkType !== _unref(DsPromoBannerNewLinkType).AppDownload)
                ? (_openBlock(), _createBlock(DsButton, {
                    key: 0,
                    size: "sm",
                    type: "primary",
                    theme: theme.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.banner.buttonText), 1)
                    ]),
                    _: 1
                  }, 8, ["theme"]))
                : (_ctx.banner.linkType === _unref(DsPromoBannerNewLinkType).AppDownload)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("a", {
                        href: _ctx.banner.appLinks.iosUrl,
                        class: "ios-only"
                      }, _cache[0] || (_cache[0] = [
                        _createElementVNode("img", {
                          src: "/frontend/web/img/design-system/store/apple.svg",
                          alt: "App store",
                          class: "button-store"
                        }, null, -1)
                      ]), 8, _hoisted_10),
                      _createElementVNode("a", {
                        href: _ctx.banner.appLinks.androidUrl,
                        class: "android-only"
                      }, _cache[1] || (_cache[1] = [
                        _createElementVNode("img", {
                          src: "/frontend/web/img/design-system/store/google-play.svg",
                          alt: "Google Play store",
                          class: "button-store"
                        }, null, -1)
                      ]), 8, _hoisted_11)
                    ], 64))
                  : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.banner.linkType !== _unref(DsPromoBannerNewLinkType).AppDownload)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: link.value,
                target: _ctx.banner.openInNewTab ? '_blank' : undefined,
                rel: _ctx.banner.openInNewTab ? 'noopener noreferrer' : undefined,
                class: _normalizeClass(["ds-promo-banner-new__link-overlay", linkClass.value]),
                onClick: onClickBanner,
                "data-game-id": _ctx.banner.linkGameExternalId,
                "data-app-event": _ctx.banner.mobileAppEvent,
                "data-app-argument": _ctx.banner.mobileAppArgument
              }, null, 10, _hoisted_12))
            : _createCommentVNode("", true)
        ], 2)
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
        _createElementVNode("button", {
          type: "button",
          class: "lotteries-stream-banner",
          onClick: openVideoStream
        }, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(DsIcon, {
                name: "video",
                width: 16,
                height: 16
              })
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "lotteries-stream-banner__badge-text" }, " Živé losování ", -1))
          ]),
          _createVNode(WebpImage, {
            src: "/frontend/web/img/lotteries/quick-lotteries/stream.jpg",
            "css-class": "lotteries-stream-banner__img",
            alt: ""
          }),
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "lotteries-stream-banner__btn" }, null, -1))
        ])
      ]))
}
}

})